/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 19.9584V12L15.1233 15.5223C16.0889 16.1861 16.5717 16.518 16.7411 16.9333C16.8894 17.2966 16.8894 17.7034 16.7411 18.0667C16.5717 18.482 16.0889 18.8139 15.1233 19.4777L12.5064 21.2768C11.6941 21.8353 11.288 22.1145 10.9504 22.0977C10.6564 22.0831 10.3837 21.9397 10.2051 21.7057C10 21.437 10 20.9441 10 19.9584Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12ZM10 12L5 9M10 12L5 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18612 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12L15.1233 15.5223C16.0889 16.1861 16.5717 16.518 16.7411 16.9333C16.8894 17.2966 16.8894 17.7034 16.7411 18.0667C16.5717 18.482 16.0889 18.8139 15.1233 19.4777L12.5064 21.2768C11.6941 21.8353 11.288 22.1145 10.9504 22.0977C10.6564 22.0831 10.3837 21.9397 10.2051 21.7057C10 21.437 10 20.9441 10 19.9584V12Z"
				fill="currentColor"
			/>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12ZM10 12V19.9584C10 20.9441 10 21.437 10.2051 21.7057C10.3837 21.9397 10.6564 22.0831 10.9504 22.0977C11.288 22.1145 11.6941 21.8353 12.5064 21.2768L15.1233 19.4777C16.0889 18.8139 16.5717 18.482 16.7411 18.0667C16.8894 17.7034 16.8894 17.2966 16.7411 16.9333C16.5717 16.518 16.0889 16.1861 15.1233 15.5223L10 12ZM10 12L5 9M10 12L5 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12ZM10 12V19.9584C10 20.9441 10 21.437 10.2051 21.7057C10.3837 21.9397 10.6564 22.0831 10.9504 22.0977C11.288 22.1145 11.6941 21.8353 12.5064 21.2768L15.1233 19.4777C16.0889 18.8139 16.5717 18.482 16.7411 18.0667C16.8894 17.7034 16.8894 17.2966 16.7411 16.9333C16.5717 16.518 16.0889 16.1861 15.1233 15.5223L10 12ZM10 12L5 9M10 12L5 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L14 9.25L13 9.9375M10 12V19.9584C10 20.9441 10 21.437 10.2051 21.7057C10.3837 21.9397 10.6564 22.0831 10.9504 22.0977C11.288 22.1145 11.6941 21.8353 12.5064 21.2768L15.1233 19.4777C16.0889 18.8139 16.5717 18.482 16.7411 18.0667C16.8894 17.7034 16.8894 17.2966 16.7411 16.9333C16.5717 16.518 16.0889 16.1861 15.1233 15.5223L10 12ZM10 12L5 16M5 9L7.5 10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12ZM10 12V19.9584C10 20.9441 10 21.437 10.2051 21.7057C10.3837 21.9397 10.6564 22.0831 10.9504 22.0977C11.288 22.1145 11.6941 21.8353 12.5064 21.2768L15.1233 19.4777C16.0889 18.8139 16.5717 18.482 16.7411 18.0667C16.8894 17.7034 16.8894 17.2966 16.7411 16.9333C16.5717 16.518 16.0889 16.1861 15.1233 15.5223L10 12ZM10 12L5 9M10 12L5 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M10 12V4.04165C10 3.05589 10 2.56301 10.2051 2.29431C10.3837 2.06029 10.6564 1.91687 10.9504 1.90226C11.288 1.88549 11.6941 2.16472 12.5064 2.72318L15.1233 4.5223C16.0889 5.18613 16.5717 5.51804 16.7411 5.93332C16.8894 6.29657 16.8894 6.70343 16.7411 7.06668C16.5717 7.48196 16.0889 7.81388 15.1233 8.4777L10 12ZM10 12V19.9584C10 20.9441 10 21.437 10.2051 21.7057C10.3837 21.9397 10.6564 22.0831 10.9504 22.0977C11.288 22.1145 11.6941 21.8353 12.5064 21.2768L15.1233 19.4777C16.0889 18.8139 16.5717 18.482 16.7411 18.0667C16.8894 17.7034 16.8894 17.2966 16.7411 16.9333C16.5717 16.518 16.0889 16.1861 15.1233 15.5223L10 12ZM10 12L5 9M10 12L5 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
